// src/components/Header.jsx
import React from "react";
import logo from "../assets/logo.png";

// Phone Icon
function PhoneIcon() {
  return (
    <svg
      className="w-5 h-5 text-white mr-2 flex-shrink-0 sm:w-5 sm:h-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22 16.92v3a2 2 0 0 1-2.18 2
        19.86 19.86 0 0 1-8.63-3.07
        19.5 19.5 0 0 1-6-6
        19.86 19.86 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.81.37 1.6.7 2.34a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.74-1.74a2 2 0 0 1 2.11-.45c.74.33 1.53.57 2.34.7A2 2 0 0 1 22 16.92z"
      />
    </svg>
  );
}

export default function Header() {
  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur border-b border-[#e8e8e8]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="py-2.5 sm:py-3 flex items-center justify-between">
          {/* Logo (external link) */}
          <a
            href="https://www.amendfinance.com/"
            aria-label="Amend Finance Home"
            className="flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFD600] rounded-lg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={logo}
              alt="Amend Finance Logo"
              width={192}
              height={48}
              className="w-32 sm:w-44 md:w-48 h-auto transition-transform duration-200 hover:scale-[1.03]"
              style={{ objectFit: "contain" }}
              loading="eager"
              decoding="async"
            />
          </a>

          {/* CTA Button */}
          <div className="flex items-center">
            <a
              href="tel:8882230171"
              className="flex items-center justify-center bg-[#0057B8] text-white font-medium px-4 py-3 sm:px-5 sm:py-3 rounded-full shadow-md transition-transform duration-200 hover:scale-[1.02] hover:bg-[#004494] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFD600]"
              style={{ boxShadow: "0 3px 12px #0057B840" }}
              aria-label="Call us now at (888) 223-0171"
            >
              <PhoneIcon />
              <div className="flex flex-col items-center leading-tight">
                <span className="text-[11px] sm:text-sm font-medium"></span>
                <span className="text-sm sm:text-lg font-bold tracking-wide">
                  (888) 223-0171
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
